export const UPCOMING_ORDERS_SOURCE = 'UpcomingOrders';
export const HOMEPAGE_SOURCE = 'Homepage';
export const WEEKLY_MENU = 'weekly_menu';

export const SHOPPABLE_SOURCE = 'Shoppable';
